(() => {
  if (window.collectionFilterDrawerCloseReady) return;
  window.collectionFilterDrawerCloseReady = true;

  const DURATION = 220;

  const isDrawerOpen = () => document.body.classList.contains('open-mobile-sidebar');

  const closeDrawer = () => {
    document.body.classList.remove('open-mobile-sidebar');
  };

  const toggleDrawerFilterBlock = (heading) => {
    if (!(heading instanceof Element)) return;

    const wrapper = heading.closest('.sidebarBlock-headingWrapper');
    if (!wrapper) return;

    const content = wrapper.nextElementSibling;
    if (!content || !content.classList.contains('sidebarBlock-contentWrapper')) return;

    if (content.dataset.animating === '1') return;
    content.dataset.animating = '1';

    const isOpen = heading.classList.contains('is-clicked');

    if (isOpen) {
      const h = content.scrollHeight;
      content.style.overflow = 'hidden';
      content.style.height = h + 'px';
      content.offsetHeight;
      content.style.transition = `height ${DURATION}ms ease-out`;
      content.style.height = '0px';
      heading.classList.remove('is-clicked');

      const onEnd = () => {
        content.removeEventListener('transitionend', onEnd);
        content.style.display = 'none';
        content.style.transition = '';
        content.style.height = '';
        content.style.overflow = '';
        content.dataset.animating = '';
      };
      content.addEventListener('transitionend', onEnd);
      setTimeout(onEnd, DURATION + 50);
    } else {
      content.style.display = 'block';
      content.style.overflow = 'hidden';
      content.style.height = '0px';
      content.offsetHeight;
      const h = content.scrollHeight;
      content.style.transition = `height ${DURATION}ms ease-out`;
      content.style.height = h + 'px';
      heading.classList.add('is-clicked');

      const onEnd = () => {
        content.removeEventListener('transitionend', onEnd);
        content.style.transition = '';
        content.style.height = '';
        content.style.overflow = '';
        content.dataset.animating = '';
      };
      content.addEventListener('transitionend', onEnd);
      setTimeout(onEnd, DURATION + 50);
    }
  };

  const isDrawerCloseControl = (target) => {
    if (!(target instanceof Element)) return false;

    const closeControl = target.closest('[data-close-sidebar], [data-collection-filter-drawer-close]');
    if (!closeControl) return false;

    return Boolean(
      closeControl.matches('[data-collection-filter-drawer-close]') ||
        closeControl.classList.contains('collection-filter-drawer__close') ||
        closeControl.classList.contains('collection-filter-drawer__apply') ||
        closeControl.classList.contains('halo-sidebar-close') ||
        closeControl.closest('.collection-filters--drawer')
    );
  };

  document.addEventListener(
    'click',
    (event) => {
      const drawerHeading = event.target instanceof Element
        ? event.target.closest('.collection-filters--drawer .sidebarBlock-headingWrapper .sidebarBlock-heading')
        : null;

      if (drawerHeading) {
        event.preventDefault();
        event.stopPropagation();
        toggleDrawerFilterBlock(drawerHeading);
        return;
      }

      if (!isDrawerCloseControl(event.target)) return;

      event.preventDefault();
      event.stopPropagation();
      closeDrawer();
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !isDrawerOpen()) return;
    if (!document.querySelector('.collection-filters--drawer')) return;
    closeDrawer();
  });
})();
